export enum ReportStatusType {
  planned = "planned",
  ready = "ready",
}
